import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * CONTACT_FORM_MESSAGES notification formatter
 * Extends notification with a link to the contact form message detail page.
 * Payload is expected to carry at least { id, subject, senderName }.
 */
export default class ContactFormMessagesFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const payload = notification.payload
    const id = payload?.id

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    if (payload?.senderName) {
      additionalParams.push({ key: 'sender', values: { name: payload.senderName } })
    }

    if (payload?.subject) {
      additionalParams.push({ key: 'subject', values: { subject: payload.subject } })
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/user-interactions/contact-messages/${id}` : undefined
    }
  }
}
